import request from '../../utils/request';

export const dcService = {
    //DC列表数据查询
    getDcData: (data) => {
        return request({
            url: '/dc/list',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    //DC信息新增/修改
    saveOrUpdateDc: (data,method) => {
        let callUrl = "/dc/edit"
        if('add' === method){
            callUrl = "/dc/new"
        }
        return request({
            url: callUrl,
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    //DC信息新增/修改
    deleteDc: (data) => {
        return request({
            url: '/dc',
            method: 'delete',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
}
